// extracted by mini-css-extract-plugin
export var card = "_80-1";
export var container = "_80-0";